export const validateWebsite = (s: string): boolean => {
  const websiteUrlRegex = /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/.*)?$/;
  const isValid = websiteUrlRegex.test(s);
  return isValid;
};